import React from 'react';
import Loading from '../../common/Loading';
import KwPanel from '../../common/KwPanel';

export interface ReportListLayoutProps {
  /** Optional filters row (e.g. YearFormSelect, CompanyFormSelect) rendered above the table */
  formFilters?: React.ReactNode;
  /** Table or other content when data is loaded */
  children: React.ReactNode;
  /** When false/undefined, show Loading instead of children */
  hasData: boolean;
}

/**
 * Shared layout for report list views: optional form filters row, then either
 * Loading (when no data) or KwPanel wrapping the table content.
 */
function ReportListLayout({ formFilters, children, hasData }: ReportListLayoutProps) {
  if (!hasData) {
    return <Loading />;
  }

  return (
    <>
      {formFilters && (
        <div className="form-horizontal row px-4 px-md-0">
          {formFilters}
        </div>
      )}
      <KwPanel className="mb-4">
        {children}
      </KwPanel>
    </>
  );
}

export default ReportListLayout;
